import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AppliancesApiService,
  AppliancesMapperService,
} from '@common/data-access-appliance-details';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppliancesEffects } from './+state/appliances/appliances.effects';
import { BrandsEffects } from './+state/brands/brands.effects';
import { CatalogEffects } from './+state/catalog.effects';
import * as fromCatalog from './+state/catalog.reducer';
import { AppliancesResolver } from './services/appliances.resolver';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromCatalog.CATALOG_FEATURE_KEY,
      fromCatalog.catalogReducer
    ),
    EffectsModule.forFeature([
      CatalogEffects,
      AppliancesEffects,
      BrandsEffects,
    ]),
  ],
  providers: [
    AppliancesApiService,
    AppliancesMapperService,
    AppliancesResolver,
  ],
})
export class SkyDataAccessCatalogModule {}
